import { useEffect, useState } from "react";
import Header from "../../Common/Header";
import Executor from "../../Components/Executor";

const ExecutorPage = () => {

  return (
      <>
        <Executor />
      </>
  );
};

export default ExecutorPage;
